import { Editor, track } from '@tldraw/tldraw'
import { observer } from 'mobx-react-lite'
import { ToolbarButton } from '../ToolbarButton'
import { Edit1 } from 'blaze-ui/icons'
import { useRootStore } from 'stores/RootStore'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { TextEditingDrawer } from 'components/Design/TextEditingDrawer/TextEditingDrawer'
import { TextBoxShape } from 'components/VisualStudioPlayground/Shapes/TextBoxShape/Types'

interface Props {
  editor: Editor
}

const MobileTextEditButton = track(
  observer(({ editor }: Props) => {
    const { drawersStore } = useRootStore()
    const selectedShape = editor.getOnlySelectedShape()
    const { isMobile } = useResponsiveDesign()
    const showEditButton =
      isMobile &&
      editor.isIn('select.idle') &&
      editor.getSelectedShapeIds().length > 0 &&
      selectedShape?.type === 'textBox'

    if (!showEditButton) return null

    return (
      <ToolbarButton
        frontIcon={Edit1}
        onPress={() => {
          drawersStore.openDrawer(TextEditingDrawer, {
            shapeProps: (selectedShape as TextBoxShape).props,
            onConfirm: (newProps) => {
              editor.updateShape({
                ...selectedShape,
                props: newProps,
              })
            },
          })
        }}
        aria-label="Edit"
      />
    )
  }),
)

export { MobileTextEditButton }
